module.exports = __webpack_public_path__ + "static/media/ProVisionsWebsitejpg.18eb04f5.jpg";